'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
//
/// This file controls the mobile menu overlay */

var MobileMenu = function () {
    function MobileMenu(module) {
        (0, _classCallCheck3.default)(this, MobileMenu);


        // Caching the overlay element.
        this.module = module;

        // Caching the mobile menu overlay close button.
        this.closeBtn = this.module.querySelector('#mobile_menu--button');

        // Caching the mobile menu hamburger button.
        this.openBtn = document.querySelector('#navbar--open');

        // Caching the last link element used to improve accessibility.
        this.lastLink = this.module.querySelector('#mobile_menu--end');

        // Caching all links in mobile menu.
        this.links = this.module.querySelectorAll('.mobile_menu--link');
    }

    // Initializes bind events.


    MobileMenu.prototype.init = function init() {
        var _this = this;

        this.openBtn.onclick = function () {
            return _this.open();
        };
        this.closeBtn.onclick = function () {
            return _this.close();
        };
        this.lastLink.onfocus = function () {
            return _this.trapFocus();
        };

        var _loop = function _loop(i, count) {
            var hash = _this.links[i].getAttribute('href');
            _this.links[i].onclick = function () {
                return _this.jumpTo(hash);
            };
        };

        for (var i = 0, count = this.links.length; i < count; i++) {
            _loop(i, count);
        }
    };

    // Shows the mobile menu overlay.


    MobileMenu.prototype.open = function open() {
        this.module.setAttribute('aria-hidden', 'false');
        this.module.setAttribute('tabindex', '0');
        this.closeBtn.focus();
    };

    // Hides the mobile menu overlay.


    MobileMenu.prototype.close = function close() {
        this.module.setAttribute('aria-hidden', 'true');
        this.module.setAttribute('tabindex', '-1');
    };

    // Used to trap keyboard focus for screen readers.


    MobileMenu.prototype.trapFocus = function trapFocus() {

        // Return the focus to the top element (close button).
        this.closeBtn.focus();
    };

    // Jumps to the given hash tag.


    MobileMenu.prototype.jumpTo = function jumpTo(hash) {

        // Close the menu first.
        this.close();

        // Load the section and jump to it.
        var section = document.querySelector(hash);
        if (section !== null) {
            section.scrollIntoView();

            if (hash === '#vince') {
                gtag('event', 'Vince McMahon', { // eslint-disable-line
                    'event_category': 'Nav', // eslint-disable-line
                    'event_action': 'click', // eslint-disable-line
                    'event_label': 'vince' // eslint-disable-line
                }); // eslint-disable-line
            }

            if (hash === '#contact') {
                gtag('event', 'Contact', { // eslint-disable-line
                    'event_category': 'Nav', // eslint-disable-line
                    'event_action': 'click', // eslint-disable-line
                    'event_label': 'contact' // eslint-disable-line
                }); // eslint-disable-line
            }
        }
    };

    return MobileMenu;
}();

// Initialize the mobile menu.


var menu = document.querySelector('#mobile_menu');
if (menu !== null) {
    var mobileMenu = new MobileMenu(menu);
    mobileMenu.init();
}
exports.default = MobileMenu;


//////////////////
// WEBPACK FOOTER
// ./src/components/mobile-menu/mobile-menu.js
// module id = 2
// module chunks = 0